/**
 * Point-of-work tutorial launcher — sits in a desk header.
 * Watch the narrated tutorial, run it live on this screen, or print the card.
 */
import { useNavigate } from "react-router-dom";
import { GraduationCap, Printer, PlayCircle } from "lucide-react";
import { useAuth } from "@/App";
import { openAuthedDoc } from "@/lib/openAuthedDoc";

export const TrainingLauncher = ({ trackId, label = "Tutorial" }) => {
  const navigate = useNavigate();
  const { token } = useAuth();

  return (
    <div className="inline-flex items-center rounded-md border border-slate-300 bg-white overflow-hidden"
      data-testid={`training-launcher-${trackId}`}>
      <span className="pl-2.5 pr-1.5 text-slate-400">
        <GraduationCap className="w-3.5 h-3.5" />
      </span>
      <button type="button"
        onClick={() => navigate(`${window.location.pathname}?walkthrough=${trackId}`)}
        className="px-2 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1"
        title="Walk me through this screen, step by step"
        data-testid={`training-launch-live-${trackId}`}>
        <PlayCircle className="w-3.5 h-3.5" /> {label}
      </button>
      <span className="w-px h-5 bg-slate-200" />
      <button type="button"
        onClick={() => navigate(`/admin/training?track=${trackId}`)}
        className="px-2 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50"
        title="Watch the narrated tutorial from the start"
        data-testid={`training-launch-watch-${trackId}`}>
        Watch
      </button>
      <span className="w-px h-5 bg-slate-200" />
      <button type="button"
        onClick={() => openAuthedDoc(`/training/quick-card/${trackId}`, { token })}
        className="px-2 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1"
        title="Print the one-page quick reference card"
        data-testid={`training-launch-card-${trackId}`}>
        <Printer className="w-3.5 h-3.5" /> Card
      </button>
    </div>
  );
};

export default TrainingLauncher;
